/** @format */
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PageBannerSVG } from "../../Assets/img/big-lkwb.svg";
import { servicesInfo } from "../../Features/HomeApi/HomeSlice";
import EachServiceCard from "../Components/services/eachservicecard";
import SEO from "../Components/Seo/Seo";

const ServicesPage = () => {
  const dispatch = useDispatch();
  const services_Info = useSelector((state) => state.home.servicesInfo);

  useEffect(() => {
    dispatch(servicesInfo());
  }, [dispatch]);

  const seo = services_Info?.service_info;

  return (
    <>
      <SEO
        title={seo?.title || "Our Services"}
        description={
          seo?.description || seo?.service_description || "Explore our services"
        }
        path={seo?.slug ? `/services/${seo.slug}` : "/services"}
        keywords={
          seo?.keywords ?
            Array.isArray(seo.keywords) ?
              seo.keywords.join(", ")
            : seo.keywords
          : "Our LKWB platform provides 5 different categories of services that will help you in every step of learning the Korean language"
        }
      />

      {/* Page Banner */}
      <div className="pageBanner">
        <PageBannerSVG />
        <Container>
          <div className="page-wrap">
            <h3>Our Services</h3>
            <span>
              Our mission at Learn Korean with Bibek is to provide high-quality,
              comprehensive Korean language instruction to individuals of all
              skill levels, from beginner to advanced.
            </span>
          </div>

          <div className="custom-shape-divider-bottom-1678688493">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </Container>
      </div>

      {/* Services List */}
      {services_Info?.services && (
        <section className="services-section-page section">
          <Container>
            <Row className="servicecard-container justify-content-center">
              {services_Info.services.map((item) => (
                <Col
                  className="eachservice-wrapper"
                  xs={12}
                  md={4}
                  key={item.id}
                >
                  <EachServiceCard
                    id={item.id} // 🔹 pass id
                    title={item.title}
                    excerpt={item.paragraph} // or item.excerpt
                    icon={item.img || item.icon}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}
    </>
  );
};

export default ServicesPage;
